import { System } from '../../_snowpack/pkg/eaciest.js';

export class InitializationSystem extends System {
  constructor () {
    super(['init']);
  }

  onEntityAdded (entity, collectionName) {
    entity.init?.(this.getEngine());
  }
}
